<template>
	<div>
		<header>
			<img src="../assets/logo.svg">
		</header>
        <div class="select-brand">

            <h2>Which product do you want to promote?</h2>
            <div class="select-box">
                <div class="brand1">
                    <div class="keaiduo ">
                        <div class="text ke">
                            <div class="ke-text brandName">
                                <p><span><b>哈根达斯</b>冰淇淋</span>TA: 18-25 Young people</p>
                                <button clickMusic='true' class="btn" @click="setData('哈根达斯')">select</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="brand1 brand2">
                    <div class="duofen ">
                        <div class="text duo">
                            <div class="duo-text brandName">
                                <p><span><b>资生堂</b>沐浴露</span>TA: 18-30 female</p>
                                <button clickMusic='true' class="btn" @click="setData('资生堂')">select</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="brand1">
                    <div class="aomiao ">
                        <div class="text ao">
                            <div class="ao-text brandName">
                                <p><span><b>花王</b>洗衣液</span>TA: 18-40 female</p>
                                <button clickMusic='true' class="btn" @click="setData('花王')">select</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="font-size: 12px;color: #535b68;text-align: center;position: fixed;bottom: 20px;width: 100%;">演示demo中出现的品牌和数据均为虚拟数据，仅供演示使用</div>

        </div>
	</div>

</template>
<style>
    a{text-decoration: none;
    }
 .select-brand{width: 1400px;margin-left: auto;margin-right: auto;}
 .select-brand h2{font-size: 36px;color: #535b68;text-align: center;width: 100%;margin: 4% 0;}
 .select-box{display: flex;width:inherit;}
 .select-box  .brand1{width: 400px;margin-top: 1%;position: relative;display: flex;}
 .select-box  .brand2{margin: 0 7%;}
 .select-box  .brand1 .keaiduo{background: url("../assets/n1.png") no-repeat  bottom;background-size: contain;width: 400px;height: 360px;}
 .select-box  .brand1 .duofen{background: url("../assets/n2.png") no-repeat center;background-size: contain;width: 400px;height: 360px;}
 .select-box  .brand1 .aomiao{background: url("../assets/n3.png") no-repeat bottom;background-size: contain;width: 400px;height: 360px;}
 .select-box  .brand1 .text{display: block;width: 210px;height: 210px;position: absolute;border-radius: 50%;}
 .select-box  .brand1 .ke{ top: 125px;  left: 65px;}
 .select-box  .brand1 .duo{top: 99px;  left: 86px;}
 .select-box  .brand1 .ao{ top: 82px;  right: 66px;}
 .select-box  .brand1 .ke-text{background: #6a1931 ;width: 210px;height: 210px;border-radius: 50%;}
 .select-box  .brand1 .duo-text{background: #cb0d27;width: 210px;height: 210px;border-radius: 50%; }
 .select-box  .brand1 .ao-text{background: #02b78e;width: 210px;height: 210px;border-radius: 50%;}
 .select-box  .brand1 .text p{font-size: 16px;font-weight: bold;color: #fff;text-align: center;padding: 60px 0 0 0}
 .select-box  .brand1 .text p span{font-size: 12px;font-weight:100;display: block;padding: 0 0 10px }
 .select-box  .brand1 .text p span b{display: inline-block;padding-right: 15px;font-size: 14px;}
.select-box  .brand1 .btn{font-size: 14px;color: #fff;border: 1px solid #fff;padding: 8px 10px;border-radius: 50px;width: 60%;display: block;margin:15px auto;cursor: pointer;}
.select-box  .brand1 .ke-text .btn{background: #6a1931 ;}
.select-box  .brand1 .duo-text .btn{background: #cb0d27;}
.select-box  .brand1 .ao-text .btn{background: #02b78e;}
.select-box  .brand1 .text p,.select-box  .brand1 .text .btn,.select-box  .brand1 .text .brandName{opacity: 0}
.select-box  .brand1 .text:hover p,.select-box  .brand1 .text:hover .btn,.select-box  .brand1 .text:hover .brandName{opacity: 1}
.select-box  .brand1 .text p{transition: all 0.2s ease-in-out;padding-top: 10px;}
.select-box  .brand1 .text:hover p {padding-top: 60px}
.select-box  .brand1 .text:hover .btn {margin: 15px auto}
.select-box  .brand1 .text .btn {transition: margin 0.2s ease-in-out,opacity 0.2s ease-in-out;transition-delay: 0.1s;margin: 40px auto}
.select-box  .brand1 .ke-text .btn:hover{background: #fff;color: #6a1931 ;}
.select-box  .brand1 .duo-text .btn:hover{background: #fff;color: #cb0d27;}
.select-box  .brand1 .ao-text .btn:hover{background: #fff;color: #02b78e;}




</style>

<script>



export default {
   name:"second",
   data(){
   	return{
   		msg:"第二页",
   		brandName:"",
   		height:{
   			height:""
   		},

   	}
   },
   methods:{

   	  setData(name){
   	  	if (window.localStorage) {
            this.clickButton();
   	  	    this.brandName = name
   	  	  	sessionStorage.setItem("BrandName", name);
            this.$router.push('second')
   	  	 }
   	  },
   	  readData(){
   	  	this.brandName = sessionStorage.getItem("BrandName")
   	  }

   },
    created() {
        console.log(window.innerHeight)
    	  this.height.height=window.innerHeight-120+'px'
      	  this.readData();
    },
    mounted() {

    }



}

</script>



// WEBPACK FOOTER //
// src/components/select.vue